// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1351":"fea8d371dc660fb4","3681":"2aafff5eeb826c60","5578":"a70ca4b6042f8ec4","8314":"5ce8b0e353215501","9227":"53477641ed576df5"}[chunkId] + ".js";
};